import React from 'react';
import { Col, Label, Input } from 'reactstrap';
import { mergeClassNames } from '@core/shared';

export function CheckboxInput({
    elementConfig,
    analyticsClassName,
    value,
    sharedLabelAttr,
    invalid,
    touched,
    shouldValidate,
    changed,
    labelId,
    renderedHelperText,
    createMarkup,
    required,
}) {
    return (
        <Col className="mb-3" md={elementConfig.columns}>
            <div className="form-check">
                <Input
                    type="checkbox"
                    value={value}
                    className={mergeClassNames(elementConfig?.className, analyticsClassName)}
                    {...sharedLabelAttr}
                    invalid={!!(invalid && touched && shouldValidate)}
                    onChange={changed}
                    required={required}
                    aria-required={required}
                />
                <Label
                    check
                    for={sharedLabelAttr.id}
                    dangerouslySetInnerHTML={createMarkup(elementConfig.label)}
                    id={labelId}
                />
                {renderedHelperText}
            </div>
        </Col>
    );
}
